import React,{Component} from 'react';
import Head from './Head'
import Foot from './Foot'
import SimpleBlogCard from './SimpleBlogCard'
import Grid from 'material-ui/Grid';

import SearchBox from './SearchBox';
import  Classfy from './Classfy'
import Label from './Label'
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import BlogContext from './BlogContext';
import { getJSON } from 'jquery'
import { CircularProgress } from 'material-ui/Progress';
class Blog extends Component{
    constructor(props){
        super(props);
        this.state={
            load:false,
            page:1,
            maxPage:1,
            blogArray:[],
            label:'',
            blogContext:false,
            blogContextId:-1
        }

    }


handleCache(){
    this.handleRecover();
    this.setState({
        load:true
    })
    getJSON('http://123.207.90.121/newBlog/api/getBlogs',{nowPage:1,pageSize:9}).then(response=>{
        const data=response.data;
        if (response.code>=1){
            this.setState({
                page:1,
                maxPage:response.code,
                blogArray:data
            })

        }else {
            this.handleLoginError();

        }
        this.setState({load:false})

    },error=> {
        this.setState({load:false})
    })
}

    componentWillMount(){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/getBlogs',{nowPage:1,pageSize:9}).then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.setState({
                    page:1,
                    maxPage:response.code,
                    blogArray:data
                })

            }else {
                this.handleLoginError();

            }
            this.setState({load:false})
        },error=> {
            this.setState({load:false})
        })
    }


    handleBlogArray(blogArray){
        this.handleRecover();
        this.setState({
            page:-1,
            blogArray:blogArray
        })
    }

    handleBlogContext(id){
        this.setState({
            blogContext:true,
            blogContextId:id
        })
    }

    handleRecover(id){
        this.setState({
            blogContext:false,
            blogContextId:-1
        })
    }


    render(){
        if (this.state.load){
            return (<table valign="medium" align="center" style={{width:'100%',height:'100%'}}>
                <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
                </td></tr></tbody></table>)
        }



        return(
            <div id="cc" style={{height:'100%',overflow: 'auto'}}>
                <Head src='image/blogHeader.jpg' title='BLOG' sentence='Connect your nerver To the system of Philosophiofantasia' />
                <div style={{backgroundImage:'url(\'image/pageBackground.jpg\')',backgroundColor:'white',backgroundSize:'cover',padding:'50px 5% 50px',
                    backgroundPositionX:'center',
                    backgroundPositionY: 'top',
                    boxShadow: '0px 10px 10px 10px  #888888 inset',minHeight:'100%'
                }}>


                   <Grid  container spacing={24}style={{display:'flex',
                                flexDirection:'row-reverse',
                                flexWrap:'warp',
                                justifyContent:'flex-start'}}>


                                <Grid item xs={12} sm={12} md={3}>
                                    <Grid container spacing={24} style={{display:'flex',
                                        flexDirection:'column',
                                        flexWrap:'warp',
                                        justifyContent:'flex-start'}}>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SearchBox handleBlogArray={this.handleBlogArray.bind(this)} />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <Classfy handleBlogArray={this.handleBlogArray.bind(this)}/>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <Label handleBlogArray={this.handleBlogArray.bind(this)}  />
                                        </Grid>
                                    </Grid>
                                </Grid>




                                <Grid item xs={12} sm={12}  md={8}>
                                    <Grid container spacing={24} >



                                        { this.state.page<1||this.state.blogContext?
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Paper
                                                    style={{background: 'white',textAlign:'center'}}>
                                            <Button size="small" color="primary" onClick={this.handleCache.bind(this)}>
                                                <i className="material-icons">cached</i>
                                            </Button>
                                                </Paper>
                                            </Grid>
                                            :
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Paper
                                                    style={{background: 'white'}}>
                                                    <Button size="small" color="primary"
                                                            onClick={this.handlePrevPage.bind(this)}>
                                                        <i className="material-icons">keyboard_arrow_left</i>PREV PAGE
                                                    </Button>
                                                    <Button size="small" style={{cssFloat: 'right'}} color="primary"
                                                            onClick={this.handleNextPage.bind(this)}>
                                                        NEXT PAGE<i className="material-icons">keyboard_arrow_right</i>
                                                    </Button>

                                                </Paper>
                                            </Grid>
                                        }


                                        {this.state.blogContext?
                                            <Grid item xs={12} sm={12} md={12}>
                                        <BlogContext id={this.state.blogContextId} handleCache={this.handleCache} />
                                            </Grid>
                                            :
                                            this.state.blogArray.map((blog)=>{

                                                return(
                                                    <Grid item xs={12} sm={6} md={4} key={blog.blogId} >

                                                        <SimpleBlogCard   title={blog.blogTitle}
                                                                          signal={blog.blogSignal} type={blog.blogType}
                                                                          imageUrl={'image/blog/'+ blog.blogImage.toString()+'.jpg'}
                                                                          id={blog.blogId}
                                                                          time={blog.blogTime} handleCache={this.handleCache.bind(this)}
                                                                          handleView={this.handleBlogContext.bind(this,blog.blogId)}

                                                        />
                                                    </Grid>
                                                )
                                            })

                                        }





                                        </Grid>

                                    </Grid>
                                    </Grid>





                </div>
                <Foot src='image/blogFooter.jpg'  sentence='It seems that a generation has passed.' info='© 2018 By Kayer'  />
            </div>
        )
    }
    handlePrevPage(){
        this.handleRecover();
        if (this.state.page<=1)
            return
        else {
            getJSON('http://123.207.90.121:8080/newBlog/api/getBlogs',{nowPage:this.state.page-1,pageSize:9}).then(response=>{
                const data=response.data;
                if (response.code>=1){
                    this.setState({
                        page:this.state.page-1,
                        maxPage:response.code,
                        blogArray:data
                    })


                }else {
                    this.handleLoginError();

                }
                this.setState({load:false})
            },error=> {
                this.setState({load:false})
            })

        }
    }

    handleNextPage(){
        this.handleRecover();
        if (this.state.page>=this.state.maxPage)
            return
        else {
            getJSON('http://123.207.90.121:8080/newBlog/api/getBlogs',{nowPage:this.state.page+1,pageSize:9}).then(response=>{
                const data=response.data;
                if (response.code>=1){
                    this.setState({
                        page:this.state.page+1,
                        maxPage:response.code,
                        blogArray:data
                    })


                }else {
                    this.handleLoginError();

                }
                this.setState({load:false})
            },error=> {
                this.setState({load:false})
            })

        }
    }

}
export default Blog;


// WEBPACK FOOTER //
// ./src/Compent/page/Blog.js